import * as React from "react";
function SvgPhone(props) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.293 10.351L11.39 8.45c-.292-.293-.878-.293-1.317 0l-1.17 1.17-4.39-4.39 1.17-1.17c.293-.293.293-.879 0-1.318L3.78.84c-.292-.293-.878-.293-1.317 0L1.146 2.156c-.878.878-.878 2.195 0 2.927l7.756 7.756c.878.878 2.196.878 2.927 0l1.317-1.317c.44-.293.44-.732.147-1.17z"
        stroke="#fff"
        strokeWidth={0.75}
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export default SvgPhone;
